import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import successAnim from "../assets/success-interaction.lottie";

const ThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Event snippet for Submit lead form conversion page
    const script = document.createElement("script");
    script.id = "lead-conversion-snippet";
    script.text = `gtag('event', 'conversion', { 'send_to': 'AW-18205272591/aN4PCNiH87ccEI_U-ehD', 'value': 1.0, 'currency': 'AED' });`;
    document.head.appendChild(script);

    return () => {
      document.getElementById("lead-conversion-snippet")?.remove();
    };
  }, []);

  return (
    <>
      <Seo
        title="Thank You — Legal Platform"
        description="Thank you for registering with Legal Platform. Our team will review your application and get back to you shortly."
        canonicalPath={process.env.REACT_APP_BASE_PATH + "/thank-you"}
        image="/favicon.png"
        noindex
      />
      <div className="privacy-bg from-top">
        <Header />
        {/* <div className="heading-policy flex-column">
          <h1>Thank You</h1>
        </div> */}
      </div>
      <Breadcrumbs />

      <div className="container data-info">
        <div className="text-center pb-5">
          <div style={{ width: "320px", height: "320px", margin: "-70px auto" }}>
            <DotLottieReact src={successAnim} autoplay />
          </div>
          <h2 className="fw-bold mt-3" style={{ color: "#1a1a1a" }}>
            Thank You!
          </h2>
          <p className="text-muted fs-5 mt-3 mb-4 mx-auto" style={{ maxWidth: "560px" }}>
            Thank you for registering with Legal Platform. Our team will review
            your application and get back to you shortly.
          </p>
          <Link
            to="/"
            className="btn btn-dark btn-lg rounded-pill px-5 py-3 fw-bold shadow-sm"
            style={{ backgroundColor: "#000", border: "none", letterSpacing: "0.5px" }}
          >
            Back to Home
          </Link>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ThankYou;
